import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

declare module 'vue/types/vue' {
  export interface Vue {
    Separator: ComponentWithProps<Props>;
  }
}

/**
 * `Separator` component properties.
 */
export interface Props {
  /** Text to be displayed within the center of the separator.  */
  text?: string;
  /** If `true`, will orient the separator vertically rather in horizontally. */
  vertical?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Separator',
  props: {
    text: null,
    vertical: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  /** Text to be displayed within the center of the separator.  */
  text?: string;
  /** If `true`, will orient the separator vertically rather in horizontally. */
  vertical?: boolean;
};



const classList = computed(() => {
  const listItems: string[] = [];

  if (props.vertical) {
    listItems.push('vertical');
  } else {
    listItems.push('horizontal');
  }

  if (props.text) listItems.push('has-text');

  return listItems;
});

return { __sfc: true,props, classList }
}

})